import '../styles/main.scss';
import Sliders from './modules/Sliders';
import Navbar from './modules/Navbar';
import Tabs from './modules/Tabs';
import Search from './modules/Search';
import Menu from './modules/Menu';
import Anchor from './modules/Anchor';
import LazyLoad from './modules/LazyLoad';

document.addEventListener('DOMContentLoaded', () => {
  new Navbar({
    selector: '.navpanel',
    fixedClass: 'is-fixed',
    offset: 100
  });

  new Navbar({
    selector: '.bottom_bnr',
    fixedClass: 'is-fixed',
    offset: 100
  });

  new Navbar({
    selector: '.nav-fixed',
    fixedClass: 'is-visible',
    offset: 1000
  });

  new Tabs({
    tab: '.recommended-plan__nav-tab a',
    content: '.recommended-plan__content-tab'
  });

  new Search();

  new Menu();

  new Anchor({
    trigger: '.footer__button-up a',
    position: 'top'
  });
});

window.onload = () => {
  new LazyLoad({ lazyImages: '.main-slider__item' });
  new LazyLoad({ lazyImages: '.main-img' });

  Sliders.mainSlider();
  Sliders.bannerCarousel();

  new LazyLoad({ lazyImages: '.appeal-point__img img' });
}
